interface MainViewLoadingProps {
  previewListItemsAmount: number;
}

export function MainViewLoading({ previewListItemsAmount }: MainViewLoadingProps) {
  return (
    <div className="mt-4 flex w-full gap-4">
      {/* Main content area skeleton */}
      <div className="flex-[7]">
        <div className="h-[35rem] w-full animate-pulse rounded-lg bg-secondary" />
        {/* Preview list skeleton */}
        <ul className="mt-4 flex flex-wrap gap-2">
          {Array.from({ length: previewListItemsAmount }, (_, i) => (
            <li key={i} className="h-20 w-[7.5rem] animate-pulse rounded-lg bg-secondary" />
          ))}
        </ul>
      </div>
      {/* Chat skeleton */}
      <div className="h-[35rem] w-[30%] animate-pulse rounded-lg bg-secondary max-lg:hidden" />
    </div>
  );
}
